/**
 * TWM related pages.
 */
import { RouteGroup } from '@/types/routing-types'


export default [
    {
        name: 'chat-widget-enable',
        path: '/chat-widget-enable',
        component: () => import('@/pages/ChatWidgetEnable/index.vue'),
        meta: {
            title: 'Enable Chat Widget',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.TWM
        }
    },
    {
        name: 'twm-after-hours-settings',
        path: '/twm-after-hours-settings',
        component: () => import('@/pages/TWMAfterHoursSettings/index.vue'),
        meta: {
            title: 'After Hours Settings',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.TWM
        }
    },
    {
        name: 'twm-custom-templates',
        path: '/twm-custom-templates',
        component: () => import('@/pages/TWMCustomTemplates/index.vue'),
        meta: {
            title: 'TWM Custom Templates',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.TWM
        }
    }
]
